export class GetTestSnapshot200Response {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "string",
            "format": ""
        },
        {
            "name": "vaultId",
            "baseName": "vaultId",
            "type": "string",
            "format": ""
        },
        {
            "name": "shadowedSnapshotId",
            "baseName": "shadowedSnapshotId",
            "type": "string",
            "format": ""
        },
        {
            "name": "jobId",
            "baseName": "jobId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GetTestSnapshot200Response.attributeTypeMap;
    }
    constructor() {
    }
}
